<div class="form-field">
  @if (enrollmentBuilderView()) {
    <div class="enrollment-form-wrapper"
         [class.horizontal-form-field]="configJson.componentType === ComponentType.HorizontalFormField"
         [class.single-form-field]="configJson.componentType !== ComponentType.HorizontalFormField"
         [class.no-input-view]="configJson.inputs && configJson.inputs.length === 0"
          [style.grid-template-columns]="'repeat(' + (configJson.inputs && configJson.inputs.length < 4 ? configJson.inputs.length + 1 : 4 ) + ', 1fr)'">
      @if (displayAdminFormField()) {
        @for (input of configJson.inputs; track input.id ?? input.localTrackId) {
          <form class="admin-form" [formGroup]="adminFormGroup">
            <div class="single-input-field-wrapper"
                 [class.horizontal-field-wrapper]="configJson.componentType === ComponentType.HorizontalFormField">
              <div class="label-icon-wrapper">
                <div class="center-labels admin-label" [class.label]="!editFormFieldInput()">
                  <label for="form-field-input" id="form-field-label">
                    {{input.label?.trim()?.length !== 0 ? input.label : InputLabel.Label1}}
                  </label>
                    @if (input.isRequired) {
                      <small class="required-asterisk" id="field-required-{{ $index }}">*</small>
                    }
                    <span [class.sublabel]="input.instructions">{{ input.instructions }}</span>
                </div>
                @if (editFormFieldInput()) {
                  <div class="icon-wrapper">
                    <button aria-label="Edit form field icon button"
                            class="icon-button" disableRipple="true"
                            mat-icon-button
                            [attr.data-qa]="'edit-form-field-icon-button-'+$index"
                            (click)="openEditDrawer($index)">
                      <i class="fa-regular fa-pen-to-square icon" [class.edit-highlight]="input.selected"></i>
                    </button>
                    <button aria-label="Remove form field icon button"
                            class="icon-button"
                            disableRipple="true"
                            mat-icon-button
                            [attr.data-qa]="'remove-form-field-icon-button-'+$index"
                            (click)="removeField($index)">
                      <i class="fa-regular fa-trash-can icon"></i>
                    </button>
                  </div>
                }
              </div>
              @switch (input.inputType) {
                @case (InputType.Text) {
                  <mat-form-field appearance="outline" class="enrollment-builder-input form-field-input"
                                  [class.form-field-edit-mode]="input.selected">
                    <input aria-labelledby="form-field-label"
                           autocomplete="off"
                           data-qa="enrollment-builder-form-field"
                           formControlName="textField"
                           id="form-field-input"
                           matInput
                           readonly
                           type="text"
                           [placeholder]="input.placeholder ?? ''"/>
                  </mat-form-field>
                }
                @case (InputType.TextArea) {
                  <div class="text-area-wrapper">
                    <mat-form-field class="text-area">
                      <textarea aria-labelledby="form-field-label"
                                class="save-prompt-note enrollment-builder-textarea"
                                data-qa="enrollment-builder-text-area"
                                formControlName="textField"
                                id="form-field-input"
                                matInput
                                readonly
                                [class.edit-mode]="input.selected" [placeholder]="input.placeholder ?? ''"></textarea>
                    </mat-form-field>
                    <div>0/{{input.max ?? 100}}</div>
                  </div>
                }
                @case (InputType.SingleSelect) {
                  <ng-container [ngTemplateOutlet]="select"></ng-container>
                }
                @case (InputType.MultiSelect) {
                  <ng-container [ngTemplateOutlet]="select"></ng-container>
                }
              }

              <ng-template #select>
                <mat-form-field appearance="outline" class="dropdown" [class.enrollment-builder-dropdown-highlight]="input.selected">
                  <mat-select aria-labelledby="form-field-label"
                              data-qa="enrollment-builder-dropdown"
                              readonly
                              [placeholder]="input.placeholder && input.placeholder.trim().length > 0 ? input.placeholder : Placeholder.Select">
                    @for (option of input.options ?? []; track $index) {
                      <mat-option [value]="option.value ?? option.label">
                        {{ option.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </div>
          </form>
        }
      }
      @if (showAddInputButton()) {
        <button class="plus-sign-button text-input-field-button"
                data-qa="add-input-button"
                mat-flat-button
                [disabled]="!enableAddTextInputButton()"
                [class.add-input-button]="configJson.inputs && configJson.inputs.length !== 0  && (configJson.componentType === ComponentType.HorizontalFormField)"
                (click)="addInputField()">
          <i class="fa-solid fa-xl font-bold fa-plus"></i> Text Input Field
        </button>
      }
    </div>
    @if (!showAddInputButton() && showInputOptions()) {
      <div class="grid-layout">
        @for (image of textFieldImages; track $index) {
          <div class="component"
               [class.disabled-image]="configJson.componentType === ComponentType.HorizontalFormField && image === SharedImages.SingleTextAreaImg">
            <img [ngSrc]="'../assets/images/'+image+'.png'" width="335" height="336" priority alt="'text field" />
            <div class="button-overlay">
              <button class="link-button"
                      disableRipple="true"
                      mat-button
                      [attr.data-qa]="'add-button-'+$index"
                      (click)="onAddComponent(image)">Add</button>
            </div>
          </div>
        }
       </div>
    }
  } @else {
    @if (formGroup()) {
      <div class="enrollment-form-wrapper household-form-wrapper"
           [class.horizontal-form-field]="configJson.componentType === ComponentType.HorizontalFormField"
           [class.single-form-field]="configJson.componentType !== ComponentType.HorizontalFormField"
           [class.no-input-view]="configJson.inputs && configJson.inputs.length === 0"
           [style.grid-template-columns]="'repeat(' + (configJson.inputs && configJson.inputs.length < 4 ? configJson.inputs.length + 1 : 4 ) + ', 1fr)'">
        @for (input of configJson.inputs | orderBy: 'order'; track input.id) {
          <form [formGroup]="formGroup()">
            <div class="form-fields-group">
              @if (input.label && input.label.length > 0) {
                <div class="center-labels text-input-label">
                  <label for="input-{{ input.id }}" id="input-{{ input.id }}-label">{{ input.label }}</label>
                  @if (input.isRequired) {
                    <small id="{{ input.id }}-field-required">*</small>
                  }
                  <span [class.margin-align]="input.instructions">{{ input.instructions }}</span>
                </div>
              }
              @switch (input.dataType) {
                @case (InputDataType.Number)  
                @case (InputDataType.SSN4)
                @case (InputDataType.ZipCode)
                @case (InputDataType.HHSize) 
                @case (InputDataType.IdNumber) {
                  <mat-form-field appearance="outline" class="enrollment-builder-input form-field-input field-size">
                    <input aria-labelledby="input-{{ input.id }}-label"
                           autocomplete="off"
                           id="input-{{ input.id }}"
                           matInput
                           pattern="^\d+$"
                           [attr.data-qa]="'text-input-' + input.id"
                           [formControlName]="input.id"
                           [max]="input.max"
                           [maxlength]="getInputMaxLength(input.dataType)"
                           [min]="input.min"
                           [placeholder]="input.placeholder ?? ''"
                           [type]="input.dataType === InputDataType.SSN4 ? InputDataType.Password : input.dataType" />
                  </mat-form-field>
                }
                @case (InputDataType.Date)
                @case (InputDataType.FullDate) {
                  <mat-form-field appearance="outline" class="enrollment-builder-input form-field-input field-size enrollment-date-picker">
                    <input
                          #datePickerInput
                          appFullDateFormat
                          id="input-{{ input.id }}"
                          matInput
                          readonly
                          [formControlName]="input.id"
                          [required]="input.isRequired"
                          [matDatepicker]="datePicker"
                          [placeholder]="input.placeholder ?? ''"
                          (click)="datePicker.open()"
                          (dateChange)="onDateSelected($event.value, input.id)" />
                      <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
                      <mat-datepicker #datePicker (closed)="formGroup().controls[input.id].markAsTouched()"></mat-datepicker>
                  </mat-form-field>
                }
                @case (InputDataType.ShortDate) {
                  <mat-form-field appearance="outline" class="enrollment-builder-input form-field-input field-size enrollment-date-picker">
                    <input
                          #datePickerInput
                          appShortDateFormat
                          id="input-{{ input.id }}"
                          matInput
                          readonly
                          [formControlName]="input.id"
                          [required]="input.isRequired"
                          [matDatepicker]="datePicker"
                          [placeholder]="input.placeholder ?? ''"
                          (click)="datePicker.open()"
                          (dateChange)="onDateSelected($event.value, input.id)" />
                      <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
                      <mat-datepicker #datePicker (closed)="formGroup().controls[input.id].markAsTouched()"></mat-datepicker>
                  </mat-form-field>
                }
                @default {
                  <mat-form-field appearance="outline" class="field-size enrollment-builder-input form-field-input"
                                  [class.textarea-field]="input.inputType === InputType.TextArea">
                    @if (isMaskedDataType(input.dataType)) {
                      <input  aria-labelledby="input-{{ input.id }}-label"
                              autocomplete="off"
                              id="input-{{ input.id }}"
                              matInput
                              [allowNegativeNumbers]="false"
                              [attr.data-qa]="'text-input-' + input.id"
                              [decimalMarker]="getDecimalMarker(input.dataType)"
                              [formControlName]="input.id"
                              [mask]="getInputMask(input.dataType)"
                              [placeholder]="input.placeholder ?? ''"
                              [prefix]="getPrefix(input.dataType)"
                              [thousandSeparator]="getThousandSeparator(input.dataType)"
                              [type]="input.dataType === InputDataType.SSN9 ? InputDataType.Password : InputType.Text" />
                    } @else if (input.placeholder === Placeholder.ProviderDegreeSchool) {
                        <input aria-labelledby="input-{{ input.id }}-label"
                               autocomplete="off"
                               id="input-{{ input.id }}"
                               matInput
                               [attr.data-qa]="'autocomplete-' + input.id"
                               [formControlName]="input.id"
                               [matAutocomplete]="schoolAuto"
                               [placeholder]="input.placeholder ?? ''" />
                        <mat-autocomplete #schoolAuto="matAutocomplete" [displayWith]="displaySchoolOption">
                          @for (option of getFilteredSchoolOptions(input); track option.value) {
                            <mat-option [value]="option.value">
                              {{ option.label }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                    } @else if (input.inputType === InputType.SingleSelect || input.inputType === InputType.MultiSelect) {
                        <mat-select aria-labelledby="select-field"
                                    class="dropdown-field"
                                    id="input-{{ input.id }}"
                                    [attr.data-qa]="'select-' + input.id"
                                    [formControlName]="input.id"
                                    [multiple]="input.inputType === InputType.MultiSelect"
                                    [placeholder]="input.placeholder && input.placeholder.trim().length > 0 ? input.placeholder : Placeholder.Select">
                          @for (option of input.options; track $index) {
                            <mat-option [value]="option.value ?? option.label">
                              {{ option.label }}
                            </mat-option>
                          }
                        </mat-select>
                    } @else if (input.inputType === InputType.TextArea) {
                      <textarea aria-labelledby="input-{{ input.id }}-label"
                                autocomplete="off"
                                class="save-prompt-note enrollment-builder-textarea"
                                id="input-{{ input.id }}"
                                matInput
                                [maxlength]="input.max"
                                [attr.data-qa]="'text-area-' + input.id"
                                [rows]="getTextareaRows(input.max)"
                                [formControlName]="input.id" [placeholder]="input.placeholder ?? ''">
                      </textarea>
                    } @else {
                      <input aria-labelledby="input-{{ input.id }}-label"
                             autocomplete="off"
                             id="input-{{ input.id }}"
                             matInput
                             [attr.data-qa]="'text-input-' + input.id"
                             [formControlName]="input.id"
                             [placeholder]="input.placeholder ?? ''"
                             [type]="input.dataType" />
                    }
                  </mat-form-field>
                  @if (input.inputType === InputType.TextArea) {
                    <mat-hint>{{ formGroup().controls[input.id].value?.length || 0}}/{{input.max}}</mat-hint>
                  }
                }
              }
              <cfi-form-inline-error [control]="formGroup().controls[input.id]" />
            </div>
          </form>
        }
      </div>
    }
  }
</div>
